import React, { useEffect } from 'react';
import {
  useHistory,
  useLocation,
  useDispatch,
  Dispatch,
  Redirect,
  Switch,
  Route,
} from '@medlinker/fundamental';

import redirectRoutes from './redirectRoutes';

let Routes: React.FC = (props: any) => {
  const location = useLocation();
  const { action } = useHistory();
  const dispatch = useDispatch() as Dispatch;

  useEffect(() => {
    if (action === 'PUSH') {
      window.scrollTo(0, 0);
    }
  }, [location.pathname, action, dispatch.app]);

  // useEffect(() => {
  //   dispatch.app.collectPU({});
  // }, [dispatch.app, location.pathname, location.search]);

  return (
    <Switch>
      {/* 生成重定向 */}
      {redirectRoutes.map(route => {
        const [originUrl, target] = route;
        let targetUrl: string = target as unknown as string;
        let search = location.search;

        if (typeof target === 'object') {
          targetUrl = target.url;
          const searchObj = new URLSearchParams(search);

          for (let key in target.query) {
            searchObj.append(key, target.query[key] + '');
          }
          search = searchObj.toString();

          if (search) search = `?${search}`;
        }

        return (
          <Redirect
            key={originUrl}
            exact
            from={originUrl}
            to={{
              pathname: targetUrl,
              search: search,
            }}
          />
        );
      })}
      <Route path="*">{props.children}</Route>
    </Switch>
  );
};

export default Routes;
